import React, { ReactElement } from 'react';

type ClubProps = {
  name: string;
  icon: string;
};

const Club = ({ icon, name }: ClubProps): ReactElement => {
  return (
    <div className="widget-result-club">
      <div className="widget-result-club-icon">
        <img src={icon} alt="" className="icon" />
      </div>
      <div className="widget-result-club-name">{name}</div>
    </div>
  );
};

export default Club;
